// extracted by mini-css-extract-plugin
export default {"backlink":"back-link_backlink__oKLqI","backlinkContent":"back-link_backlinkContent__OrFnt","icon":"back-link_icon__b8jxU","text":"back-link_text__EeT6S"};